import { useGetCustomerState } from '@api/lendingAPI/lapiHooks';
import { tracking } from '@iwoca/frontend-tracking-library';
import { Card } from '@iwoca/orion';
import { NEW_IwLinkButton } from '@iwRouter/NEW_IwLinkButton';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { twMerge } from 'tailwind-merge';

import { useStateKey } from '../../../../../iwQueryClient/useStateKey';
import {
    mapProductStatusToStep,
    TGetProductOffersResponse
} from '../ApplicationPendingView';

const DE_LEGAL_FORMS_THAT_ARENT_AUTO_LENDING_LEGIBLE: string[] = [
    'gmbh',
    'ug',
    'gmbh_u_co_kg',
    'kg',
    'ag',
    'eg'
] as const;

type TProps = {
    suggestedProductStatus?: TGetProductOffersResponse['data']['products'][number]['status'];
    productOffersStatus: ReturnType<typeof mapProductStatusToStep>;
};
export const PendingViewActionsDE = ({
    suggestedProductStatus,
    productOffersStatus
}: TProps) => {
    const stateKey = useStateKey();
    const { data: customerStateResponse } = useGetCustomerState(stateKey);
    const showAddADGButton =
        DE_LEGAL_FORMS_THAT_ARENT_AUTO_LENDING_LEGIBLE.includes(
            customerStateResponse?.application?.company?.type
                ? customerStateResponse?.application?.company?.type
                : 'no_type_found'
        );

    if (productOffersStatus !== 'documentsReview') {
        return null;
    }

    return (
        <Card>
            <div className="w-full text-left">
                <h3>
                    <FormattedMessage
                        id="_.pending_view.quick_actions.title"
                        defaultMessage="Quick actions"
                    />
                </h3>

                <Card
                    className={twMerge(
                        classNames('items-left mt-[15px] p-[25px]')
                    )}
                >
                    <h3>
                        <FormattedMessage
                            id="_.pending_view.upload_documents.title"
                            defaultMessage="Upload documents"
                        />
                    </h3>
                    <div className="text-left">
                        {suggestedProductStatus === 'pending_documents' && (
                            <FormattedMessage
                                id="_.pending_view.upload_documents.pending_docs_message"
                                defaultMessage="If you need to upload documents, click here:"
                            />
                        )}
                        {suggestedProductStatus ===
                            'pending_document_review' && (
                            <FormattedMessage
                                id="_.pending_view.upload_documents.pending_doc_review_message"
                                defaultMessage="If you would like to upload more documents, click here:"
                            />
                        )}
                    </div>
                    <NEW_IwLinkButton
                        className={twMerge(
                            classNames('mt-[15px] w-full min-sm:max-w-[300px]')
                        )}
                        to={{
                            pathname: '/trading/'
                        }}
                        onClick={() =>
                            tracking.ampli.uploadDocumentsCtaClicked({
                                suggested_product_status:
                                    suggestedProductStatus || 'undefined_status'
                            })
                        }
                    >
                        <FormattedMessage
                            id="_.pending_view.upload_documents.upload_button"
                            defaultMessage="Go to document uploader"
                        />
                    </NEW_IwLinkButton>
                </Card>
                {showAddADGButton && (
                    <Card>
                        <div className="text-left">
                            <h3>
                                <FormattedMessage
                                    id="_.pending_view.add_guarantor.title"
                                    defaultMessage="Add an additional guarantor"
                                />
                            </h3>
                            <FormattedMessage
                                id="_.pending_view.add_guarantor.description"
                                defaultMessage="If you have multiple directors and want to add an additional guarantor click the button below"
                            />
                        </div>
                        <NEW_IwLinkButton
                            className={twMerge(
                                classNames(
                                    'mt-[15px] w-full min-sm:max-w-[300px]'
                                )
                            )}
                            to={{
                                pathname: '/company/'
                            }}
                        >
                            <FormattedMessage
                                id="_.pending_view.add_guarantor.button"
                                defaultMessage="Go to your director list"
                            />
                        </NEW_IwLinkButton>
                    </Card>
                )}
            </div>
        </Card>
    );
};
